@if(networkStatus === 'offline') {
<div class="network-warning">
  You are currently offline. Please check your internet connection.
</div>
}
